import * as React from 'react';

function SvgSoundOn(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.971 10.79l5.515-4.122a.7.7 0 011.119.56v16.155a.7.7 0 01-1.12.56l-5.514-4.128H5.1a.7.7 0 01-.7-.7V11.49a.7.7 0 01.7-.7h2.87zm5.234-2.164L8.623 12.05a.7.7 0 01-.42.14H5.802v6.225h2.403a.7.7 0 01.42.14l4.58 3.43V8.624zm8.785-1.398a.7.7 0 00-.05.989 10.264 10.264 0 012.653 7.076c.049 2.636-.9 5.166-2.652 7.102a.7.7 0 101.037.94 11.658 11.658 0 003.015-8.042 11.646 11.646 0 00-3.014-8.016.7.7 0 00-.99-.049zm-2.265 2.089a.7.7 0 00-.017.99 6.973 6.973 0 011.957 4.985 6.985 6.985 0 01-1.957 5.006.7.7 0 101.007.973 8.366 8.366 0 002.35-5.979 8.354 8.354 0 00-2.35-5.958.7.7 0 00-.99-.017zm-2.211 3.115a.7.7 0 11.926-1.05 5.057 5.057 0 011.717 3.873 5.089 5.089 0 01-1.677 3.902.7.7 0 01-.939-1.04 3.707 3.707 0 001.217-2.858 3.675 3.675 0 00-1.244-2.827z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgSoundOn;
